(function (fox, $, undefined) {

	fox.registerWidget('LSFans', {
		configure: function () {
			this.urefs = {};

			this.registerOptions('', {
				autoRender: true,
				widgets: {
					fanList: {
						widget: 'AdvancedList',
						autoRender: true,
						'hooks.onStopAddedToDom': function () {
							$(this.element[0]).parents('.fan-list-scroll-wrapper').mCustomScrollbar({
								theme: 'minimal-dark'
							});
						},
						handleDom: {
							sendToUser: {
								event: 'click',
								target: '#send-to-user',
								callback: '@parent:sendToUser'
							}
						}
					}
				},
				handleWom: {
					onRoomJoin: {
						event: 'room_join',
						widget: '@root #uchatctrl',
						'params.alwaysActive': true,
						callback: function (msg, uchatctrl) {
							var member = uchatctrl.prepareUserObject(msg.member);
							
							if (msg.room === this.currentRoom && uchatctrl.userId != member.uid) {
								return this.prepareUserData([member]).then((prepared) => {
									this.dispatchEvent('roomJoin', prepared[0]);
								}).catch(() => {
									this.dispatchEvent('roomJoin', member);
								});
							}
						}
					},
					onRoomLeave: {
						event: 'room_leave',
						widget: '@root #uchatctrl',
						'params.alwaysActive': true,
						callback: function (msg, uchatctrl) {
							var member = uchatctrl.prepareUserObject(msg.member);
							
							if (msg.room == this.currentRoom && uchatctrl.userId != member.uid) {
								var userData = this.removeUser(member.uid);

								return this.dispatchEvent('roomLeave', userData || member);
							}
						}
					}
				}
			});

			this.callParent('configure', arguments);
		},

		activate: function () {
			this.callParent('activate', arguments);

			if (this.getUsersAmount() === 0) {
				this.getUsers();
			}
		},

		getUsers: function () {
			var uchatctrl = this.rwom1('@root #uchatctrl');
			
			uchatctrl.getRoomUsers(this.currentRoom).then(function (users) {
				this.prepareUserData(users.filter(function (u) {return u.uid != uchatctrl.userId;}));
			}.bind(this));
		},

		getfl: function () {
			return this.rwom1('#fanList');
		},

		prepareUserData: function (users) {
			if (fox.isEmpty(users))
				return false;

			if (!fox.isArray(users) && fox.isObject(users))
				users = fox.toArray(users);

			const api = this.getApi('userInfo', {method: 'liveshow.getUsers', sendTimezone: true});
				
			const undefinedUsers = users
				.filter(({ uid }) => uid.match(/^guest_/) !== null)
				.map(user => ({ ...user, name: user.uid.replace(/^guest_/, 'Guest '), isGuest: true }));
			const userIds = users.filter(({ uid }) => uid.match(/^guest_/) === null).map(({ uid }) => uid);

			const prepare = (_p) => _p.map((p) => ({
				...p,
				uid: p.id
			}));

			const promises = [];
			if (userIds.length)
				promises.push(api.psend({ userIds })
					.then(resp => prepare(resp.params.answer.response)));

			if (undefinedUsers.length)
				promises.push(fox.Promise.resolve(undefinedUsers))

			this.__addUsersProgress = promises.reduce((prev, next) => {
				return prev.then(_users => next.then(__users => _users.concat(__users)));
			}, fox.Promise.resolve([])).then(_users => {
				this.addUsers(_users);

				this.__addUsersProgress = null;
				return _users;
			}).catch((res) => {
				this.addUsers(users);
				this.__addUsersProgress = null;
			});

			return this.__addUsersProgress;
		},

		addUsers: function (users) {
			if (!fox.isArray(users) && fox.isObject(users)) {
				users = fox.toArray(users);
			}

			var active = this.isActive();

			fox.each(users, function (user, indx) {
				return this.addUser(user, indx === users.length && active);
			}, this);

			return this;
		},

		addUser: function (user, render) {
			if (!this.urefs.hasOwnProperty(user.uid)) {
				if (this.getfl()._rendered === true) {
					return this.getfl()
						.wait('@this', 'addedToDom', {
							prefix: (Math.random() * Math.pow(10, 10)).toFixed()
						}).then(fox.bind(function () {
							this.addUser(user, render);
						}, this));
				}

				var id = this.getfl().appendItem(user, render !== undefined ? render : !this.isActive()).pop();

				this.urefs[user.uid] = id;
				this.dispatchEvent('fansAmountChanged');
			}

			return this;
		},

		removeUser: function (uid) {
			var user;

			if (uid in this.urefs) {
				user = this.getfl().getDataById(this.urefs[uid]);

				if (user !== false) {
					this.getfl().remove(user.indx);
					delete this.urefs[uid];
					this.dispatchEvent('fansAmountChanged');

					user = user.data;
				}
			}

			return user;
		},

		getUsersAmount: function () {
			return this.getfl().getLength();
		},

		reset: function () {
			this.urefs = {};
			this.getfl().resetCollection();
			this.dispatchEvent('fansAmountChanged');
		},

		sendToUser: function (el) {
			const uid = $(el).parents('.user-actions').data('user-id');
			const user = this.getfl().filter('uid', uid).pop();

			if (!fox.isEmpty(user)) {
				this.dispatchEvent('sendToUser', user.value);
			}
		},

		getModelId: function () {
			if (!this.modelId) {
				var buff = this.getfl().filter('isBroadcaster', true).pop();

				if (fox.objectGet(buff, 'value.uid')) {
					this.modelId = fox.objectGet(buff, 'value.uid');
				}
			}

			return this.modelId;
		},

		setCurrentRoom: function (roomId) {
			this.currentRoom = roomId;

			return this;
		},

		getUserInfoFromList: function (uid) {
			if (this.__addUsersProgress)
				return this.__addUsersProgress.then(() => this.getfl().getDataById(this.urefs[uid]));

			return fox.Promise.resolve(this.getfl().getDataById(this.urefs[uid]));
		}
	});

})(fox, fox.jQuery);



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/widget/Fans.es.js